import React from 'react'
import i18next from 'i18next'
import memoizeOne from 'memoize-one'
import { Row, Col, Badge, Button, ListGroup } from 'react-bootstrap'
import { format } from 'date-fns'
import { Trans } from 'react-i18next'
import { Virtuoso } from 'react-virtuoso'
import styles from './message_list.module.css'
import RefreshingMask from 'src/components/system_wide/responsive_table/refreshing_mask'

import 'react-quill-new/dist/quill.snow.css'

const { t } = i18next
class MessageList extends React.Component {
  static defaultProps = {
    manageMessage: false,
    data: [],
    getData: () => {},
    chunkSize: 50,
    hideStatusBar: false,
    showTotals: true,
    scrollToMessageId: null,
    onDelete: () => {},
    onMarkMessage: () => {},
    onShowDetails: () => {},
    onChangeRecipients: () => {},
    onShowUsersDetails: () => {},
  }

  state = {
    useWindowScroll: false,
    completed: false,
    refreshing: false,
    lastChunkSize: 0,
    headerPadding: 0,
    sort_column: '',
    sort_direction: '',
  }

  mediaQueryList = null
  resizeObserver = null
  virtuosoRef = null
  constructor(props) {
    super(props)
    this.virtuosoRef = React.createRef()
  }

  async componentDidMount() {
    await this.loadMore()
    if (this.props.scrollToMessageId) {
      const messageIndex = this.props.data.findIndex(msg => msg.id === this.props.scrollToMessageId)
      if (messageIndex !== -1) {
        this.virtuosoRef.current.scrollToIndex(messageIndex, {
          behavior: 'smooth', // Animazione fluida
          align: 'start', // Allineamento all'inizio dell'elemento
        })

        this.showMessageDetails(messageIndex, this.props.data[messageIndex])()
        this.props.onScollEnd()
      }
    }
  }

  async componentDidUpdate(prevProps) {
    let { length: oldLength } = prevProps.data
    let { length: newLength } = this.props.data
    if (newLength !== oldLength) {
      this.setState({ lastChunkSize: newLength - oldLength })
    }
    if (prevProps.filter !== this.props.filter) {
      let { sort_column, sort_direction } = this.state
      this.setState({ refreshing: true })
      await this.props.getData(0, this.props.chunkSize, { sort_column, sort_direction }, this.props.filter)
      this.virtuosoRef.current.scrollToIndex(0)
      this.setState({ refreshing: false })
    }
  }

  loadMore = memoizeOne(async () => {
    let { data = [], chunkSize } = this.props
    let start = data.length
    let { sort_column, sort_direction } = this.state

    if (start !== 0 && start >= this.props.totalRecords) {
      this.setState({ completed: true })
      return
    }

    if (this.state.lastChunkSize === 0 || this.state.lastChunkSize === chunkSize) {
      this.setState({ completed: false })
    }

    await this.props.getData(start, chunkSize, { sort_column, sort_direction }, this.props.filter)

    if (this.state.completed === false) this.setState({ completed: true })
  })

  refreshData = async () => {
    let { sort_column, sort_direction } = this.state
    let { data = [], chunkSize } = this.props
    let limit = Math.ceil(data.length / chunkSize) * chunkSize
    this.setState({ refreshing: true })
    await this.props.getData(0, limit || chunkSize, { sort_column, sort_direction }, this.props.filter)
    this.setState({ refreshing: false })
  }

  onSortChange = async sortKey => {
    let { sort_column, sort_direction } = this.state
    let new_sorting_configs = {}
    if (sortKey !== sort_column) {
      new_sorting_configs = { sort_column: sortKey, sort_direction: 'ASC' }
    } else {
      if (sort_direction === 'ASC') {
        new_sorting_configs = { sort_direction: 'DESC' }
      } else {
        new_sorting_configs = { sort_column: '', sort_direction: '' }
      }
    }
    this.setState(new_sorting_configs, async () => {
      await this.refreshData()
    })
  }

  showMessageDetails = (index, msg) => () => {
    if (!msg.read_at) {
      this.props.onMarkMessage(index)
    }
    let _msg = { ...msg }
    _msg.message = _msg.message.replace(/<img(.*?)src="([^"]+)"(.*?)>/g, (match, p1, p2, p3) => {
      return `<img${p1}src="${p2}"${p3} class="img-fluid" style="max-height: 200px; width: auto;" />`
    })
    this.props.onShowDetails(_msg)
  }

  render() {
    const { completed, useWindowScroll, refreshing } = this.state
    const { data, hideStatusBar, showTotals, totalRecords, manageMessage } = this.props

    return (
      <div className="d-flex flex-column flex-fill">
        <Virtuoso
          className=" flex-fill"
          ref={this.virtuosoRef}
          data={data}
          endReached={this.loadMore}
          useWindowScroll={useWindowScroll}
          itemContent={(index, msg) => (
            <ListGroup.Item
              key={index}
              className={`d-flex flex-column border-0 ${
                msg.read_at ? 'bg-light' : 'bg-white'
              } rounded-3 mb-3 shadow-sm`}
              style={{ padding: '20px' }}>
              <Row className="align-items-center">
                <Col>
                  <div className="d-flex mb-3 flex-column">
                    <div className="d-flex align-items-center mb-1">
                      {!msg.read_at && (
                        <Badge bg="success" className="me-2">
                          {manageMessage && (
                            <>
                              <span className="me-2">{msg.users.length}</span>
                              <i className="fa fa-users me-2 mb-0" />
                            </>
                          )}
                          <Trans i18nKey="components.messages.message_list.new_message">Nuovo</Trans>
                        </Badge>
                      )}
                      {manageMessage && (
                        <Badge
                          bg="success"
                          className="me-2"
                          role="button"
                          onClick={() => this.props.onShowUsersDetails(msg)}>
                          <span className="me-2">{msg.users.length}</span>
                          <i className="fa fa-users me-2 mb-0" />
                        </Badge>
                      )}
                      <h5 className="mb-0" style={{ fontSize: '1.2rem', fontWeight: '600', display: 'inline-block' }}>
                        {msg.title}
                        {manageMessage && (
                          <i
                            className="fa fa-edit ms-2 text-muted"
                            style={{ cursor: 'pointer' }}
                            onClick={this.props.onChangeRecipients(index)}
                          />
                        )}
                      </h5>
                    </div>
                    {manageMessage === false && (
                      <div className="text-muted small">
                        <b className="me-2">
                          <Trans i18nKey="components.messages.message_list.read_at">Letto il</Trans>:
                        </b>
                        {msg.read_at ? format(msg.read_at, 'yyyy-MM-dd HH:mm') : ''}
                      </div>
                    )}
                  </div>
                  {/* <div className="ql-editor" style={{ fontSize: '1rem' }}>
                    {parse(msg.message)}
                  </div> */}
                </Col>
                <Col md="12">
                  <div className="d-flex align-items-center">
                    <small className="text-muted" style={{ fontSize: '0.9rem' }}>
                      <Trans i18nKey="components.messages.message_list.sent_at">Inviato il</Trans>{' '}
                      {new Date(msg.created_at).toLocaleDateString()}
                    </small>

                    <div className="d-flex ms-auto">
                      {manageMessage === false && msg.read_at && (
                        <Button
                          variant={msg.read ? 'outline-secondary' : 'outline-success'}
                          size="sm"
                          className=""
                          onClick={() => this.props.onMarkMessage(index)}
                          style={{ transition: 'background-color 0.3s ease' }}>
                          <i className={`fas ${msg.read_at ? ' fa-eye-slash' : ' fa-eye'} fa-eye me-0`} />
                          <div className="d-none d-md-inline">
                            <Trans i18nKey="components.messages.message_list.mark_as_unread">
                              Segna come non letto
                            </Trans>
                          </div>
                        </Button>
                      )}
                      {manageMessage === true && (
                        <Button
                          variant="outline-danger"
                          size="sm"
                          className=""
                          onClick={() => this.props.onDelete(index)}
                          style={{ transition: 'background-color 0.3s ease' }}>
                          <i className="fas fa-trash-alt me-0" />
                          <div className="d-none d-md-inline">
                            <Trans i18nKey="components.messages.message_list.delete">Elimina</Trans>
                          </div>
                        </Button>
                      )}
                      <Button
                        variant="outline-primary"
                        size="sm"
                        className=" ms-2"
                        onClick={this.showMessageDetails(index, msg)}
                        style={{ transition: 'background-color 0.3s ease' }}>
                        <i className="fas fa-info-circle me-0" />
                        <div className="d-none d-md-inline">
                          <Trans i18nKey="components.messages.message_list.show_message">Visualizza</Trans>
                        </div>
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>
            </ListGroup.Item>
          )}
          components={{
            Footer: () => {
              return completed ? null : (
                <div className={styles.last_row} style={{ position: data.length ? 'relative' : 'absolute' }}>
                  <Trans i18nKey="system_wide.responsive_table.loading">Caricamento...</Trans>
                </div>
              )
            },
          }}
        />
        {hideStatusBar !== true && (
          <>
            <div className={`d-flex align-items-center py-2 bg-body-tertiary responsive_table_footer ${styles.footer}`}>
              <div className="flex-fill text-contrast-light">
                {showTotals && `${t('system_wide.responsive_table.total_record', 'Totale record')}: ${totalRecords}`}
              </div>
              <button className="btn btn-primary py-0" onClick={this.refreshData}>
                <i className="fas fa-sync-alt fa-fw me-0" />
              </button>
            </div>
            <RefreshingMask isRefreshing={refreshing} />
          </>
        )}
        {data.length === 0 && (
          <div className={`${styles.norecords} ${'d-flex justify-content-center align-items-center'}`}>
            <div className="px-4 py-2 bg-light border">
              <b>
                <Trans i18nKey="components.messages.message_list.no_records">Nessun messaggio disponibile</Trans>
              </b>
            </div>
          </div>
        )}
      </div>
    )
  }
}

export default MessageList
